import { render } from "./ContactView.vue?vue&type=template&id=3cd09860&scoped=true"
const script = {}

import "./ContactView.vue?vue&type=style&index=0&id=3cd09860&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3cd09860"]])

export default __exports__